/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Quote_2_TextInputs */

const da_forside_quote_2_text = /** @type {(inputs: Forside_Quote_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det bedste er, at den markerer de opgaver, hvor den er i tvivl. Så ved jeg præcis, hvor jeg skal kigge, og resten kan jeg skimme.`)
};

/** @type {(inputs: Forside_Quote_2_TextInputs) => LocalizedString} */
const en_forside_quote_2_text = da_forside_quote_2_text;

/**

* @param {Forside_Quote_2_TextInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_quote_2_text = /** @type {((inputs?: Forside_Quote_2_TextInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Quote_2_TextInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_quote_2_text(inputs)
	return /** @type {LocalizedString} */ ("Det bedste er, at den markerer de opgaver, hvor den er i tvivl. Så ved jeg præcis, hvor jeg skal kigge, og resten kan jeg skimme.")
});